import {v4 as uuidv4} from "uuid";

export type SponsorListItem = {
    SponsorshipTierId: string;
    EventId: string;
    SponsorId: string;
    Notes: string | null;
    Name: string;
    Link: string;
    LogoSmall: string;
    LogoMedium: string;
    LogoLarge: string;
    LogoBanner: string;
    CommitmentDate: string;
    DonationAmount: number;
    SortOrder: number;
    PartnerId: string;
};

export type SponsorshipTierListItem = {
    SponsorshipTierId: string;
    Name: string;
    Description: string;
    MinDonation: number;
    MaxDonation: number;
    SortOrder: number;
    EventId: string;
}

export type TierListItem = {
    SponsorshipTierId: string;
    Name: string;
    Description: string;
    MinDonation: number;
    MaxDonation: number;
    SortOrder: number;
    EventId: string;
};

export function newSponsorInfo(): SponsorListItem {
    return {
        SponsorshipTierId: "",
        EventId: "",
        SponsorId: uuidv4(),
        Notes: "",
        Name: "",
        Link: "",
        LogoSmall: "",
        LogoMedium: "",
        LogoLarge: "",
        LogoBanner: "",
        CommitmentDate: "",
        DonationAmount: 0,
        SortOrder: 0,
        PartnerId: "",
    };
}
export function emptySponsorInfo(): SponsorListItem {
    return {
        SponsorshipTierId: "",
        EventId: "",
        SponsorId: "",
        Notes: "",
        Name: "",
        Link: "",
        LogoSmall: "",
        LogoMedium: "",
        LogoLarge: "",
        LogoBanner: "",
        CommitmentDate: "",
        DonationAmount: 0,
        SortOrder: 0,
        PartnerId: "",
    };
}
